import chain from '@/lib/axios-chain'

// 根据角色获取列表
export const getMenuOptions = () => chain.create('/inquiry/config/getviewlist', 'get')

// 获取视图列表
export const getViewList = () => chain.create('/inquiry/view/listview', 'get')

// 获取视图功能开关状态
export const getSwitchView = () => chain.create('/inquiry/view/getswitchview', 'get')

// 开启|关闭视图功能
export const setSwitchView = () => chain.create('/inquiry/view/switchview', 'post')

// 创建视图
export const createView = () => chain.create('/inquiry/view/createview', 'post')

// 编辑视图
export const editView = () => chain.create('/inquiry/view/editview', 'post')

// 获取视图条件
export const getQuery = () => chain.create('/inquiry/view/getquery', 'get')

// 删除视图
export const deleteView = () => chain.create('/inquiry/view/delview', 'post')

// 设置默认视图
export const setDefaultView = () => chain.create('/inquiry/view/setdefault', 'post')

// 启用视图
export const setEnableView = () => chain.create('/inquiry/view/setenable', 'post')

// 视图排序
export const setSort = () => chain.create('/inquiry/view/setsort', 'post')
